import {
  ProductPurchaseOption,
  productShopifyIdMap,
} from 'content/products/productMap';

/**
 * True when `merchandiseId` is exclusively a Special Prices (X) SKU.
 *
 * A gid that is also mapped as `oneTimePurchase` (AE OTP 1/3/12 reused on
 * US `special_*_us`) must not be treated as a UHX companion — otherwise
 * healCart deletes a standalone OTP line when no UHX is in the cart.
 */
export function isXOptionCompanion(merchandiseId: string | undefined): boolean {
  if (!merchandiseId) return false;
  const matches = Object.values(productShopifyIdMap).filter(
    (config) => config.shopifyVariantId === merchandiseId,
  );
  return (
    matches.length > 0 &&
    matches.every((config) => config.type === ProductPurchaseOption.x)
  );
}
